import { render, staticRenderFns } from "./GenerateReply.vue?vue&type=template&id=ed24e412"
import script from "./GenerateReply.vue?vue&type=script&lang=js"
export * from "./GenerateReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports